import axios from "axios";
import React, { useEffect, useState } from "react";
import { NGROK } from "../../../APIs";
import { myLocalStorage } from "../../../components/StorageHelper";
import useUserStore from "../../../services/userStore";
import AzureGenericRoles from "./Components/AzureGenericRoles";
import { CustomTabPanel } from "../../../GenericMethods";
import K8Roles from "./Components/K8Roles";
import { SiKubernetes } from "react-icons/si";
import { Shield as ShieldIcon } from "@mui/icons-material";
import TailwindFilterHeader from "../../../tailwind-ui/components/TailwindFilterHeader";
import useCloudSyncStore from "../../../services/useCloudSyncStore";
import { triggerCloudSync } from "../../../triggerCloudSync";
import useNotificationStore from "../../../services/notificationStore";

const AzureRoles = () => {
  const [selectedTenantName, setSelectedTenantName] = useState(null);
  const [tenantList, setTenantList] = useState([]);
  const [isSyncing, setIsSyncing] = useState(false);
  const [tabValue, setTabValue] = useState("Roles");
  const syncStatus = useCloudSyncStore((state) => state.syncStatus);
  let { azureConfig } = useNotificationStore.getState();
  const [subList, setSubList] = useState([]);
  const [selectedSubList, setSelectedSubList] = useState(null);
  const latestSubList =
    myLocalStorage.getItem("latestSubList")?.subscriptionName;
  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;

  const userData = useUserStore((state) => state.user);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const ondemandButton = async () => {
    try {
      const data = await triggerCloudSync(
        "azure",
        "/api/azure-sync/onDemand",
        selectedTenantName,
      );
      console.log("Azure Sync complete:", data);
    } catch (error) {
      console.error("Azure Sync failed", error);
    }
  };

  const handleTenantChange = (value) => {
    const tenant = tenantList.find((tenant) => tenant.tenantName === value);
    if (tenant) {
      setSelectedTenantName(tenant.tenantName);
      myLocalStorage.setItem("latestTenant", tenant);
    }
  };

  const handleSubscriptionChange = (value) => {
    const sub = subList.find((subs) => subs?.subscriptionName === value);
    if (sub !== undefined) {
      setSelectedSubList(sub);
      myLocalStorage.setItem("latestSubList", sub);
    }
  };

  const fetchSubList = async () => {
    try {
      const response = await axios.get(
        `${NGROK}/api/azureResources/v1/all?tenantName=${latestTenant}&type=SUBSCRIPTION`,
      );

      const subs = response?.data || [];
      setSubList(subs);

      if (subs.length > 0) {
        let latest = null;

        try {
          latest =
            typeof latestSubList === "string"
              ? JSON.parse(latestSubList)
              : latestSubList;
        } catch (e) {
          latest = null;
        }

        const match = latest
          ? subs.find(
              (item) => item?.subscriptionName === latest?.subscriptionName,
            )
          : null;

        const selected = match || subs[0];

        setSelectedSubList(selected);

        myLocalStorage.setItem("latestSubList", JSON.stringify(selected));
      } else {
        setSelectedSubList(null);
      }
    } catch (error) {
      console.error("Failed to fetch subscriptions:", error);
      setSubList([]);
      setSelectedSubList(null);
    }
  };

  useEffect(() => {
    if (tenantList.length === 1) {
      setSelectedTenantName(tenantList[0].tenantName);
    } else if (tenantList.length > 1) {
      const latestTenantName =
        myLocalStorage.getItem("latestTenant")?.tenantName;
      const tenant = tenantList.find((t) => t.tenantName === latestTenantName);
      setSelectedTenantName(
        tenant ? tenant.tenantName : tenantList[0].tenantName,
      );
    }
  }, [tenantList]);

  useEffect(() => {
    fetchSubList();
  }, [selectedTenantName, latestTenant]);

  useEffect(() => {
    const fetchTenants = async () => {
      const response = await axios.get(`${NGROK}/api/get-all-domains`);
      setTenantList(response.data);
    };
    fetchTenants();
  }, [userData]);

  return (
    <div className="flex flex-col h-full bg-background">
      <div className="px-6 py-5 bg-card border-b border-border">
        <TailwindFilterHeader
          title="Azure Roles"
          isIconNeeded={true}
          subtitle={"Manage cloud roles and permissions"}
          dropdowns={[
            {
              label: "Tenant",
              value: selectedTenantName,
              options: tenantList.map((t) => ({
                label: t.tenantName,
                value: t.tenantName,
              })),
              onChange: handleTenantChange,
            },
            {
              label: "Subscription",
              value: selectedSubList?.subscriptionName,
              options: subList.map((t) => ({
                label: t?.subscriptionName,
                value: t?.subscriptionName,
              })),
              onChange: handleSubscriptionChange,
            },
          ]}
          tabs={[
            { label: "Roles", value: "Roles", icon: ShieldIcon },
            { label: "Kubernetes", value: "K8", icon: SiKubernetes },
          ]}
          activeTab={tabValue}
          onTabChange={setTabValue}
          isSyncing={syncStatus["azure"]}
          onSync={ondemandButton}
          isSyncNeeded={azureConfig ? true : false}
        />
      </div>

      <div className="flex-1 overflow-auto">
        <CustomTabPanel value={tabValue} index="Roles">
          <AzureGenericRoles subscription={selectedSubList} />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index="K8">
          <K8Roles
            selectedTenantName={selectedTenantName}
            allapi={`/api/azureResources/v1/all?type=AZURE_KUBERNETES&tenantName=${selectedTenantName}`}
            rolesApi="/api/k8-resources/v1/roles/byClusterId"
            rolespoliciesApi="/api/k8-resources/v1/rolePolicies/byRoleUid"
            cloud="AZURE"
          />
        </CustomTabPanel>
      </div>
    </div>
  );
};

export default AzureRoles;
